import React from 'react';
import { JobListSkeleton } from './SkeletonLoader';
import JobsTable from '../../Components/JobsTable';
import { useCompanyAccess } from '@/HireWithUs/Context/CompanyAccessContext';

// Presentational: receives jobs from parent so Overview makes only one get_jd request (useJob in OverviewSubComponent).
function RecentJobList({
  jobs = [],
  jobsLoading = false,
  onRefreshJobs,
  handleViewApplications,
  onViewJobDescription,
  onPinJob,
  onDeleteJob,
}) {
  const { can } = useCompanyAccess();

  if (jobsLoading && (!jobs || jobs.length === 0)) {
    return <JobListSkeleton />;
  }

  return (
    <JobsTable
      jobs={Array.isArray(jobs) ? jobs : []}
      loading={jobsLoading}
      error={null}
      title="Recently Posted Jobs"
      handleViewApplications={handleViewApplications}
      onViewJobDescription={onViewJobDescription}
      onPinJob={can('jobs.edit') ? onPinJob : undefined}
      onDeleteJob={can('jobs.close') ? onDeleteJob : undefined}
      loadingComponent={<JobListSkeleton />}
    />
  );
}

export default RecentJobList;